import React, { useEffect, useState } from 'react';
import {
	getNotifications,
	sendNotificationsAcknowledgement,
} from '../../../logic/functions/notifications.function';
import { Notification } from '../../presentational/Notification/Notification';

interface Props {
	updateFocusOnNotificationClose: () => void;
}

export const NotificationsContainer = (props: Props) => {
	const [isOpen, setOpen] = useState(false);
	const [notification, setNotification] = useState({
		id: NaN,
		content: '',
		title: '',
		type: '',
	});

	useEffect(() => {
		const fetchData = async () => {
			const result = (await getNotifications()) as any;
			if (
				result &&
				result.popupNotifications &&
				result.popupNotifications.length > 0
			) {
				setNotification(result.popupNotifications[0]);
				setOpen(true);
			}
		};
		fetchData();
	}, []);

	const closeNotifications = (acknowledged: boolean) => {
		if (acknowledged) {
			sendNotificationsAcknowledgement(notification.id);
		}
		setOpen(false);
		props.updateFocusOnNotificationClose();
	};

	return isOpen ? (
		<Notification
			notification={notification}
			closeNotification={closeNotifications}
		/>
	) : null;
};

export default NotificationsContainer;
